// @flow
import * as React from 'react';
import isEqual from 'react-fast-compare';
import LoggedInMenu from './LoggedInMenu';
import LoggedOut from './LoggedOut';

type Props = {
    baseUrl: string,
    logOutBidder: Function,
    mobile: string,
    openLoginModal: Function,
    openSignUpModal: Function,
    parent: any,
    pathname: string,
    userDataLoading: boolean,
    userFirstName: string,
    userLoggedIn: boolean,
    whiteLabel: boolean,
    windowWidth: number,
};

const Login = (props: Props) => {
    const {
        baseUrl,
        logOutBidder,
        mobile,
        openLoginModal,
        openSignUpModal,
        parent,
        pathname,
        userDataLoading,
        userFirstName,
        userLoggedIn,
        whiteLabel,
        windowWidth,
    } = props;

    return userLoggedIn || userDataLoading ? (
        <LoggedInMenu
            baseUrl={baseUrl}
            logOutBidder={logOutBidder}
            mobile={mobile}
            parent={parent}
            pathname={pathname}
            userFirstName={userFirstName}
            whiteLabel={whiteLabel}
            windowWidth={windowWidth}
        />
    ) : (
        <LoggedOut openSignUpModal={openSignUpModal} openLoginModal={openLoginModal} />
    );
};

export default React.memo<Props>(Login, isEqual);
